import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import bin from '../../../images/bin.svg'; // TODO: use another icon

export function StopActionIcon({ onClick }) {
    const { t } = useTranslation();

    return (
        <OverlayTrigger placement="top" overlay={ props => <Tooltip {...props}>{t('reports.stop_plans.action_tooltip')}</Tooltip>}>
            <img src={bin} alt="stop" className="action-icon" onClick={onClick} />
        </OverlayTrigger>
    );
}
